export default "assets/images/icons/home-marker-b4953f4f.svg";